<template>
  <div>
    <ui-ask-danger ref="ask"/>
    <ui-form class="bg-white space-y-6" @submit.prevent.stop="save">
      <div>
        <h3 class="text-lg leading-6 font-medium text-gray-900">Вопросы и задания</h3>
        <p class="mt-1 text-sm text-gray-500">
          Добавьте вопросы и задания, вам необходимо указать текст вопроса, выбрать тип ответа, установить количество
          баллов и казать правильные ответы.
        </p>
      </div>
      <div v-for="(question,i) in items" :key="i" class="border-gray-200 pt-2 border-t">
        <!-- :class="{'border-t': i > 0}"-->

        <div>
          <dt class="text-lg leading-7 flex justify-between items-start">
            <div class="text-left flex text-gray-400 cursor-pointer w-full" @click="active = active === i ? null : i ">
              <h1 class="font-medium text-gray-600" :class="{'text-gray-900': active === i}">
                #{{ i + 1 }}. {{ question.name }}
              </h1>
            </div>

            <div class="flex">
<!--
              <button type="button" class="flex mr-3" @click="clone(i)">
                <DuplicateIcon class="h-5 w-5 my-auto text-blue-400  hover:text-blue-500"/>
              </button>
-->

              <button type="button" class="flex" @click="remove(i)">
                <TrashIcon class="h-5 w-5 my-auto text-red-400 hover:text-red-500"/>
              </button>

            </div>
          </dt>
          <event-edit-question :index="i" :show="active === i"/>
        </div>
      </div>
      <div class="group relative my-3 cursor-pointer" @click="addQuestion">
        <div class="absolute inset-0 flex items-center">
          <div class="w-full border-t border-primary-300 group-hover:border-primary-400"></div>
        </div>
        <div class="relative flex justify-center text-sm leading-5">
            <span class="px-2 bg-white text-primary-600 text-xs group-hover:text-primary-800">
              добавить вопрос
            </span>
        </div>
      </div>


      <div class="py-3 text-right">
        <ui-button v-show="isModify" @click="save">Сохранить</ui-button>
      </div>
    </ui-form>

  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import UiForm from "@/components/ui/form/UiForm";
import UiButton from "@/components/ui/button/UiButton";
import EventEditQuestion from "@/views/events/edit/questions/EventEditQuestion";
import {DuplicateIcon, TrashIcon} from '@heroicons/vue/outline'
import UiAskDanger from "@/components/ui/ask/UiAskDanger";


export default {
  name: "EventEditQuestions",
  // eslint-disable-next-line vue/no-unused-components
  components: {UiAskDanger, DuplicateIcon, TrashIcon, EventEditQuestion, UiButton, UiForm},
  data() {
    return {
      active: 0,
    }
  },
  computed: {
    ...mapGetters('event/questions', {items: 'all', isModify: 'is_changed', length: 'length'}),
  },
  methods: {
    ...mapActions('event/questions', ['save']),
    async addQuestion() {
      await this.$store.dispatch('event/questions/add')
      this.active = this.items.length - 1;
    },
    remove(index) {
      this.$refs.ask.show({title: `Удалить вопрос №${index + 1}`}).then(() => {
        this.$store.dispatch('event/questions/deleteItem', index)
      })
    },
    clone(index) {
      this.$store.dispatch('event/questions/cloneItem', {index})
      this.active = this.items.length - 1;
    },

  },
}
</script>